// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import store from "./store";
import router from "./router";
import VueResource from "vue-resource";
import Cookies from "js-cookie";
import { IS_DEV } from "./utils/config";
import { BASE_URL } from "./utils/config";
import VueI18n from "vue-i18n";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/zh-CN"; // lang i18n
import "./assets/css/tailwind.css";
import "../static/css/mainStyle.css"; // 引入全局样式文件
import "./plugins/gsap";

Vue.config.productionTip = false;
Vue.prototype.$store = store;
Vue.prototype.$cookies = Cookies;
Vue.prototype.$isDev = IS_DEV;
Vue.prototype.$BASE_URL = BASE_URL;

Vue.use(VueResource);
Vue.use(ElementUI, { locale });
Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const i18n_locale = Cookies.get("locale");

const i18n = new VueI18n({
  locale: i18n_locale || "zh_CN", // 设置默认语言环境
  fallbackLocale: i18n_locale || "zh_CN", // 设置后备语言环境
  messages: loadLocaleMessages(), // 通过函数加载翻译文件
});

// 修改主题色
// document.documentElement.style.setProperty('--el-color-primary', '#61AC85')

/* eslint-disable no-new */
new Vue({
  i18n,
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js